import { render } from "./StatViewManagerHospitals.vue?vue&type=template&id=36a0c20a&scoped=true"
import script from "./StatViewManagerHospitals.vue?vue&type=script&lang=js"
export * from "./StatViewManagerHospitals.vue?vue&type=script&lang=js"

import "./StatViewManagerHospitals.vue?vue&type=style&index=0&id=36a0c20a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a0c20a"]])

export default __exports__